import { useState } from "react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useToast } from "@/hooks/use-toast";
import type { Promocode } from "@shared/types/schema";
import axiosClient from "@/lib/axiosClient";

interface PromoCodeInputProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onApply: (promocode: Promocode) => void;
}

export function PromoCodeInput({
  open,
  onOpenChange,
  onApply,
}: PromoCodeInputProps) {
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);
  const { toast } = useToast();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!code) return;

    setLoading(true);
    try {
      const res = await axiosClient.post("/api/promocodes/validate", {
        code: code.toUpperCase(),
      });
      const result = res.data;
      if (result.valid && result.promocode) {
        onApply(result.promocode);
        onOpenChange(false);
        toast({
          title: "Успех",
          description: "Промокод успешно применён",
        });
      } else {
        toast({
          variant: "destructive",
          title: "Ошибка",
          description: result.message || "Неверный промокод",
        });
      }
    } catch (error) {
      toast({
        variant: "destructive",
        title: "Ошибка",
        description:
          error instanceof Error
            ? error.message
            : "Не удалось применить промокод",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="user-layout">
        <DialogHeader>
          <DialogTitle>Ввести промокод</DialogTitle>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4">
          <Input
            className="space-y-2 uppercase placeholder:normal-case"
            id="promocode"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            placeholder="Впишите его вот сюда"
          />
          <Button className="w-full" type="submit" disabled={loading || !code}>
            {loading ? "Проверка..." : "Применить"}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
